module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Hdjiu4/tc-custom/9781605099439.jpg?1737809042879",
      "alt": "This image is the cover for the book Rebooting the American Dream"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rebooting the American Dream\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“If we are going to live in a democracy, we need to have a healthy middle class . . . tells us what needs to be done to reclaim what it is to be American.” —Eric Utne, founder, "), _c('i', [_vm._v("Utne Reader")])]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" America does not need an “upgrade.” For years the Right has been tampering with one of the best political operating systems ever designed. The result has been economic and environmental disaster."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In this hard-hitting book, nationally syndicated radio and television host and bestselling author Thom Hartmann outlines eleven common-sense proposals, deeply rooted in America’s history, that will once again make America strong and Americans—not corporations and billionaires—prosperous. Some of these ideas will be controversial to both the Left and the Right, but the litmus test for each is not political correctness—but whether or not it serves to revitalize this country we all love and make life better for its citizens.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Thom Hartmann\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Thom Hartmann is the nation’s leading progressive talk radio host, heard on over a hundred stations, as well as on XM and Sirius radio, and seen on live nationwide television via the Free Speech TV network. He is the bestselling author of twenty books, including Unequal Protection, Threshold, Screwed, Cracking the Code, and The Last Hours of Ancient Sunlight.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Berrett-Koehler Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0